// extracted by mini-css-extract-plugin
export default {"fullWidth":"Oh-z","hasStyledAspectRatio":"Ph-z"};